module.exports = __webpack_public_path__ + "img/umr_sleeping.88cbe9ae.gif";